<div class="w-full">
  <div class="text-center">
    <h4>Redirect to okta login page</h4>
    <div class="lds-ripple"><div></div><div></div></div>
  </div>
</div>
